<template>
	<li class="express-type-freight clearfix" >
		<div class="type">
			<div class="ui-ico-sfi">
				{{productName}}
			</div>
		</div>
		<div class="type">
			<!--寄付价-->
			<p class="hard" v-if="showDeliverFreight || !rateInfo.destWeightUnit">
				{{rateInfo.weight+rateInfo.weightUnit}}
			</p>
			<!--到付价-->
			<p class="hard" v-else>{{rateInfo.destWeight+rateInfo.destWeightUnit}}</p>
		</div>
		<div class="type" v-if="rateInfo.deliverTime">
			<p class="hard">{{rateInfo.deliverTime}}工作日</p>
		</div>
		<div class="type" v-else><p class="hard">&nbsp;&nbsp;</p></div>
		<div class="type">
			<!--寄付价-->
			<p class="hot" v-if="showDeliverFreight">{{(rateInfo.freight+rateInfo.fuelCost) +
				(rateInfo.currencyName === "人民币" ? "元" : rateInfo.currencyName)}}</p>
			<!--到付价-->
			<p class="hot" v-else-if="RegionGroup.filterList.indexOf(this.$store.state.payFee.selectDestAreaCode) !== -1">
				{{_ll('暂未开通')}}
			</p>
			<p class="hot" v-else>{{(rateInfo.destFreight+rateInfo.destFuelCost) +
				(rateInfo.destCurrencyName === "人民币" ? "元" : rateInfo.destCurrencyName)}}</p>
		</div>
	</li>
</template>

<script>
	import {RegionGroup} from '../../constant/common'
    export default {
        name: "PayFeeInternational",
		data () {
			return {
				RegionGroup: RegionGroup
			}
		},
		props: {
			showDeliverFreight: {
				type: Boolean,
				defaultValue: true
			},
			rateInfo: {
				addTime: String,
				cargoTypeCode: String,
				cargoTypeName: String,
				currencyName: String,
				deliverTime: String,
				destCurrencyName: String,
				destDistributionFreight: Number,
				destFreight: Number,
				destFuelCost: Number,
				destFuelFlg: Boolean,
				destPickupFreight: Number,
				destTransportFreight: Number,
				destView: String,
				destWeight: Number,
				destWeightUnit: String,
				distanceTypeCode: String,
				distanceTypeName: String,
				distributionFreight: Number,
				expectArriveTm: String,
				expressTypeCode: String,
				freight: Number,
				fuelCost: Number,
				internet: Boolean,
				limitTypeCode: String,
				limitTypeName: String,
				orgionView: String,
				otherService: String,
				pickupFreight: Number,
				productCode: String,
				regionFreight: Number,
				totalFreight: Number,
				transportFreight: Number,
				weight: Number,
				weightUnit: String
			}
		},
		computed: {
			isShowCargoType: function () {
				return !(this.rateInfo.orgionView === '1' && (this.rateInfo.destView === '1'
					|| this.rateInfo.destView === '2'))
			},
			productName: function () {
				if (this.rateInfo.cargoTypeName) {
					return this.isShowCargoType ? this.rateInfo.limitTypeName +
						'(' + this.rateInfo.cargoTypeName + ')' : this.rateInfo.limitTypeName
				} else {
					return this.rateInfo.limitTypeName
				}
			}
		}
    }
</script>

<style scoped>
	.express-type-freight {
		padding: 10px;
		overflow: hidden;
	}
	.clearfix {
		zoom: 1;
	}
	li:first-child {
		border-top: 0;
	}
	li {
		list-style: none;
		background-color: #fff;
		border-bottom: #ddd 1px solid;
	}
	.type {
		display: inline-block;
		float: left;
		color: #333;
		word-break: break-all;
	}
	.express-type-freight .type:nth-of-type(1) {
		width: 30%;
	}
	.express-type-freight .type:nth-of-type(2) {
		width: 20%;
	}
	.express-type-freight .type:nth-of-type(3) {
		width: 30%;
	}
	.ui-ico-sfi {
		display: inline-block;
		background-repeat: no-repeat;
		vertical-align: middle;
	}
	.hard {
		color: #333;
	}
	.hot {
		color: #ed2210;
	}
</style>



// WEBPACK FOOTER //
// src/pages/payFee/pay-fee-international.vue